import React, { useState, useEffect } from "react";
import { db } from "../../../config/firebase";
import { collection, addDoc } from "firebase/firestore";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import "./UploadCategory.css";

function UploadCategory() {
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const seoSlug = name.toLowerCase().replace(/\s+/g, "-");
      const coverImage = image ? await uploadToCloudinary(image) : "";
      await addDoc(collection(db, "categories"), {
        name,
        slug: seoSlug,
        coverImage,
        createdAt: new Date(),
      });
      alert("Category added successfully!");
      setName("");
      setImage(null);
      setPreview(null);
    } catch (err) {
      console.error(err);
      alert("Error adding category");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!image) {
      setPreview(null);
      return;
    }
    const url = URL.createObjectURL(image);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [image]);

  return (
    <div className="upload-category-container">
      <div className="upload-card">
        <h2>Add Category</h2>
        <form className="upload-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label className="form-label">Category Name</label>
            <input
              type="text"
              placeholder="Category Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="form-row image-row">
            <div>
              <label className="form-label">Cover Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
                required
              />
            </div>
            <div className="image-preview">
              {preview ? <img src={preview} alt="preview" /> : <div className="placeholder">No image</div>}
            </div>
          </div>

          <div className="form-actions">
            <button className="btn primary" type="submit" disabled={loading}>{loading?"Adding...":"Add Category"}</button>
            <button type="button" className="btn ghost" onClick={() => { setName(""); setImage(null); setPreview(null); }}>Reset</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UploadCategory;